import { z } from 'zod';
import { addressSchema } from '../../Address.js';
import { payableDataSchema } from '../../Payable.js';
import { deliveryServiceConfigSchema } from '../configurations/DeliveryServiceConfig.js';
import { servicesProviderGenericDataSchema, supportObjectSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderDeliveryDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.DELIVERY]: deliveryServiceConfigSchema,
    }),
    physicalAddress: addressSchema,
    support: supportObjectSchema,
});

export { servicesProviderDeliveryDataSchema };
//# sourceMappingURL=ServicesProviderDeliveryData.js.map
